module.exports = __webpack_public_path__ + "static/media/kidsHomeBackground.67a4295b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/KidsHomePage/kidsHomeBackground.svg
// module id = 902
// module chunks = 0